import React from 'react';
import ContactUs from '../../pageComponents/ContactUs';

const ContactUsPage = () => <ContactUs />;

export default ContactUsPage;
